module.exports = __webpack_public_path__ + "img/tarjeta-debito.d7ad304c.webp";